module.exports = __webpack_public_path__ + "img/minus-icon.7c413c0e.svg";